export const version = {
  timeStamp: '2026-07-13 04:12:36 PM ',
  version: '0.0.5',
};
